/* ==========================================================================
   SPICY HOME - ASSURANCES
   Two small, independent behaviours. Neither is load-bearing: the section
   is fully legible as a static grid without either running.

     1. Pointer spotlight - --mx/--my set to the pointer's position inside
        the hovered column only, as percentages. CSS does the rest (a
        radial-gradient glow, opacity toggled on :hover/:focus-within).
     2. Numeral count-up - each column's oversized index counts from 00 to
        its real number the first time it scrolls into view, a single beat
        before the copy settles.
   ========================================================================== */

(function () {
  'use strict';

  function init(root) {
    if (root.__assurancesBooted) return;
    root.__assurancesBooted = true;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sh-mark]'));
    if (!items.length) return;

    /* ---- 1. pointer spotlight -------------------------------------------
       One delegated listener on the grid rather than one per column: a
       column only pays for the glow while the pointer is actually inside
       it, via the CSS :hover gate - this just supplies the coordinates. */
    var grid = root.querySelector('.sh-marks__grid');
    if (grid && window.matchMedia('(pointer: fine)').matches) {
      grid.addEventListener('pointermove', function (e) {
        var item = e.target.closest ? e.target.closest('[data-sh-mark]') : null;
        if (!item) return;
        var rect = item.getBoundingClientRect();
        var mx = ((e.clientX - rect.left) / rect.width) * 100;
        var my = ((e.clientY - rect.top) / rect.height) * 100;
        item.style.setProperty('--mx', mx + '%');
        item.style.setProperty('--my', my + '%');
      });
    }

    /* ---- 2. numeral count-up ---------------------------------------------
       Reduced motion: show the final number immediately, no animation. */
    var nums = items
      .map(function (item) { return item.querySelector('[data-sh-mark-num]'); })
      .filter(Boolean);

    if (reduced || !nums.length) {
      nums.forEach(function (el) { el.textContent = el.getAttribute('data-count-to') || el.textContent; });
      return;
    }

    function countUp(el) {
      if (el.__counted) return;
      el.__counted = true;
      var target = parseInt(el.getAttribute('data-count-to'), 10);
      if (!target && target !== 0) return;
      var duration = 500;
      var start = null;

      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3); // ease-out-cubic
        var current = Math.round(eased * target);
        el.textContent = current < 10 ? '0' + current : String(current);
        if (p < 1) window.requestAnimationFrame(frame);
      }
      window.requestAnimationFrame(frame);
    }

    if (!('IntersectionObserver' in window)) {
      nums.forEach(countUp);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var num = entry.target.querySelector('[data-sh-mark-num]');
        if (num) countUp(num);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    items.forEach(function (item) { io.observe(item); });
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-sh-marks]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); }, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
